import React from 'react';
import { Shield, Mail, Globe } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#07223a] border-t border-sky-900/40 py-8 md:py-12 px-3 md:px-4" data-id="element-69">
      <div className="max-w-4xl mx-auto flex flex-col items-center text-center" data-id="element-70">
        <div className="flex items-center gap-2 text-sky-400 font-bold tracking-[0.2em] uppercase mb-4 md:mb-6 text-xs md:text-sm" data-id="element-71">
          <Shield className="w-4 h-4 md:w-5 md:h-5 text-sky-400" data-id="element-72" />
          DIGITALPREMIUM™
        </div>

        <p className="text-slate-400 text-sm md:text-lg mb-6 md:mb-10 max-w-md" data-id="element-73">
          Porque hoy proteger a tus hijos también es entender el mundo digital.
        </p>

        <div className="flex flex-col md:flex-row items-center gap-3 md:gap-6 mb-8 md:mb-12 text-slate-400 text-xs md:text-base" data-id="element-74">
          <a href="mailto:ayudadigitalpremium@gmail.com" className="flex items-center gap-1.5 hover:text-white transition-colors" data-id="element-75">
            <Mail className="w-4 h-4 md:w-5 md:h-5" data-id="element-76" />{' '}
            ayudadigitalpremium@gmail.com
          </a>
          <span className="hidden md:block text-slate-700" data-id="element-77">•</span>
          <a href="https://digitalpremium.online" className="flex items-center gap-1.5 hover:text-white transition-colors" data-id="element-78">
            <Globe className="w-4 h-4 md:w-5 md:h-5" data-id="element-79" /> digitalpremium.online
          </a>
        </div>

        <p className="text-slate-500 text-[11px] md:text-sm" data-id="element-80">
          © DigitalPremium 2026 Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}